import { ReactElement } from 'react';
import { UrlLink } from '../../applink/UrlLink';
import { TrackPageViewContainer } from '../../common/containers/TrackPageViewContainer';
import { t } from '../../common/getTranslations';
import { requestContext } from '../../common/requestContext';
import { Divider } from '../../design-system/atoms/Divider/Divider';
import { Icon } from '../../design-system/atoms/Icon/Icon';
import { IconType } from '../../design-system/atoms/Icon/IconType.enum';
import { Text } from '../../design-system/atoms/Text/Text';
import { Layout } from '../../design-system/layout/Layout';
import { KakaoentPolicyLink } from '../../domain/policy/presentational/KakaoentPolicyLink';
import { KakaoentPolicyType } from '../../domain/policy/type';
import { CommonMobileHeaderType } from '../../header/constants';
import { LOG_CLICK_EVENT } from '../../logging/logEvent';
import { putTiaraObjectProps } from '../../logging/putTiaraObjectProps';
import { theme } from '../../theme';
function Support() {
  const {
    isMobile
  } = requestContext.requestInfo.display;
  return <div className="font-medium2 flex flex-col px-15pxr text-theme-solid-100" {...putTiaraObjectProps({
    click: {
      layer1: '고객센터'
    }
  })}>
      {!isMobile && <h1 className="font-large3-bold mt-20pxr mb-32pxr py-14pxr">
          {t('more_customer')}
        </h1>}
      <Text className="font-small2 pt-30pxr text-theme-solid-40">
        {t('more_customer_faq')}
      </Text>
      <UrlLink url="/help">
        <div className="flex py-20pxr" onClickCapture={e => LOG_CLICK_EVENT('도움말_클릭', e)}>
          <Text className="flex-1">{t('more_customer_help')}</Text>
          <Icon type={IconType.ListArrowRight} />
        </div>
      </UrlLink>
      <Divider color={theme.colors['theme-transparent-10']} />
      <UrlLink url={'/ask'}>
        <div className="flex py-20pxr" onClickCapture={e => LOG_CLICK_EVENT('문의하기_클릭', e)}>
          <Text className="flex-1">{t('more_customer_cs_title')}</Text>
          <Icon type={IconType.ListArrowRight} />
        </div>
      </UrlLink>
      <Divider color={theme.colors['theme-transparent-10']} />
      <>
        <UrlLink url="/credit-refund/agreement">
          <div className="flex py-20pxr" onClickCapture={e => LOG_CLICK_EVENT('캐시환불접수_클릭', e)}>
            <Text className="flex-1">{t('more_customer_cash_refund')}</Text>
            <Icon type={IconType.ListArrowRight} />
          </div>
        </UrlLink>
        <Divider color={theme.colors['theme-transparent-10']} />
      </>

      <Text className="font-small2 pt-30pxr text-theme-solid-40">
        {t('more_customer_terms_info')}
      </Text>
      <KakaoentPolicyLink policyType={KakaoentPolicyType.TargetAd}>
        <div className="flex py-20pxr" onClickCapture={e => LOG_CLICK_EVENT('맞춤형광고안내_클릭', e)}>
          <Text className="flex-1">{t('more_customer_terms_optimized')}</Text>
          <Icon type={IconType.ListArrowRight} />
        </div>
      </KakaoentPolicyLink>
      <Divider color={theme.colors['theme-transparent-10']} />

      <TrackPageViewContainer trackObj={{
      section: '더보기',
      page: '고객센터',
      actionType: 'Pageview',
      actionName: '고객센터_화면',
      customProps: {
        user_action: 'pv'
      }
    }} />
    </div>;
}
Support.getLayout = function getLayout(page: ReactElement) {
  return <Layout title={t('more_customer')} mobileLayoutConfig={{
    shouldShowHeader: true,
    headerType: CommonMobileHeaderType.ThreeDepth
  }} pcLayoutConfig={{
    shouldShowHeader: true
  }}>
      {page}
    </Layout>;
};
export default Support;